import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { useGetPaymentMethodsQuery } from "../../../hooks/useGetPaymentMethodsQuery";
import { updatePaymentMethod } from "../../../services/finance/paymentMethods";
import { Key_paymentMethods } from "../../../utils/constants";
import { PaymentMethodType } from "../../../types/Finance";
import { useAppDispatch } from "../../../hooks/hooks";
import { routes } from "../../../routes";
import { setPaymentMethodData } from "../../../redux/slices/finance/paymentMethod";
import { Lists } from "../../../components/common/Lists";
import TableComponent from "../../../components/common/Tables";
import { ConfirmAlertDialog } from "../../../components/common/ConfirmAlertDialog";

const columnNamesMap: { [key: string]: string } = {
    description: 'Nome',
};
export const PaymentMethods = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [deleteItem, setDeleteItem] = useState<PaymentMethodType | null>(null);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const { data, status } = useGetPaymentMethodsQuery({ PageNumber: currentPage, PageSize: 400 });

    const mutationUpdate = useMutation(updatePaymentMethod, {
        onSuccess: () => {
            queryClient.invalidateQueries(Key_paymentMethods);
            toast.success('Apagado');
        },
        onError: () => {
            toast.error("Erro ao apagar.")
        }
    });

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleClickCreate = (event: any): void => {
        navigate(routes.createPaymentMethod)
    }
    const handleEdit = (p: PaymentMethodType) => {
        dispatch(setPaymentMethodData(p));
        navigate(routes.updatePaymentMethod)
    };

    const handleDelete = async (p: PaymentMethodType) => {
        p.status = false;
        await mutationUpdate.mutateAsync(p)
    };
    const confirmDelete = async () => {
        if (deleteItem) {
            await handleDelete(deleteItem!)
        }
    };
    const openDeleteDialog = (c: PaymentMethodType) => {
        setDeleteItem(c);
    };


    const options = data?.items.map((p: PaymentMethodType) => [
        {
            label: 'Editar',
            onClick: (role: PaymentMethodType) => handleEdit(p),
            icon: <Pencil1Icon />
        },
        {
            label: 'Eliminar',
            onClick: () => openDeleteDialog(p),
            icon: <TrashIcon />
        },
    ]) || [];

    return (
        <>
            <Lists
                status={status}
                TableComponent={() =>
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                    />
                }
                handleClickCreate={handleClickCreate}
            />
            <ConfirmAlertDialog
                open={!!deleteItem}
                onOpenChange={(open) => !open && setDeleteItem(null)}
                title="Esta operação é irreversível"
                description="A forma de pagamento será eliminada e deixará de estar disponível."
                confirmLabel="Eliminar"
                item={deleteItem}
                onConfirm={confirmDelete}
                onCancel={() => setDeleteItem(null)}
            />
        </>
    );
}